/*
 * EPDM Cart Protection
 * Locks the quantity (= length in feet) of EPDM liner line items in the cart,
 * since quantity changes would silently change the cut length.
 *
 * Liner items are matched by SKU pattern CAR-<digits>FT (CAR-05FT, CAR-10FT, ... CAR-50FT)
 * or by the _unique_id property ("epdm_...") stamped by the product-page dimension
 * selector — so any width variant added in the future is covered automatically,
 * no list to maintain.
 */
(function () {
  var EPDM_SKU_PATTERN = /CAR-\d+FT/;
  var LOCK_MESSAGE =
    'EPDM Liner lengths cannot be modified. Please remove the item and add a new selection with the desired length.';

  document.addEventListener('DOMContentLoaded', function () {
    monitorCartAPIRequests();
    initEPDMCartProtection();
    setInterval(initEPDMCartProtection, 2000);
    document.addEventListener('cart:refresh', initEPDMCartProtection);
    document.addEventListener('cart:updated', initEPDMCartProtection);
    document.addEventListener('drawer:open', initEPDMCartProtection);
  });

  // DOM-side check: does this rendered cart row contain a liner SKU?
  function isEPDMLineItem(cartItem) {
    return EPDM_SKU_PATTERN.test(cartItem.textContent || '');
  }

  // API-side check: is this /cart.js line item a liner?
  function isEPDMCartApiItem(item) {
    if (!item.properties) return false;
    if (
      typeof item.properties._unique_id === 'string' &&
      item.properties._unique_id.indexOf('epdm_') === 0
    ) {
      return true;
    }
    if (
      typeof item.properties.SKU === 'string' &&
      EPDM_SKU_PATTERN.test(item.properties.SKU)
    ) {
      return true;
    }
    return false;
  }

  function initEPDMCartProtection() {
    document
      .querySelectorAll('[data-cart-item], .cart-item, .cart__item')
      .forEach(function (cartItem) {
        if (!isEPDMLineItem(cartItem)) return;

        var quantityInput = cartItem.querySelector('input[name^="updates"]');
        if (!quantityInput || quantityInput.getAttribute('data-locked')) return;

        var originalValue = quantityInput.value;

        quantityInput.setAttribute('data-locked', 'true');
        quantityInput.disabled = true;
        quantityInput.style.backgroundColor = '#f0f8ff';
        quantityInput.style.border = '1px solid #0066cc';
        quantityInput.style.cursor = 'not-allowed';
        quantityInput.style.color = '#0066cc';
        quantityInput.style.fontWeight = 'bold';

        // Hide the +/- stepper buttons
        cartItem
          .querySelectorAll(
            '.quantity__button, .quantity-adjuster__button, .plus, .minus, .quantity__button--plus, .quantity__button--minus'
          )
          .forEach(function (button) {
            button.style.display = 'none';
          });

        // Insert the explanatory note once per row
        if (!cartItem.querySelector('.epdm-quantity-notice')) {
          var noteElement = document.createElement('div');
          noteElement.className = 'epdm-quantity-notice';
          noteElement.style.color = '#0066cc';
          noteElement.style.fontSize = '0.9em';
          noteElement.style.padding = '8px 12px';
          noteElement.style.margin = '8px 0';
          noteElement.style.backgroundColor = '#f0f8ff';
          noteElement.style.borderLeft = '3px solid #0066cc';
          noteElement.style.borderRadius = '2px';
          noteElement.innerHTML =
            'Length cannot be modified in cart. Please remove and re-select a new size if needed.';

          var itemDetails =
            cartItem.querySelector(
              '.cart-item__details, .cart-item__content, .cart__item-details, .cart__item-content'
            ) || cartItem;
          itemDetails.insertBefore(noteElement, itemDetails.firstChild);
        }

        // Belt-and-braces: revert any value change that sneaks through
        quantityInput.addEventListener('change', function () {
          if (this.value != originalValue) {
            this.value = originalValue;
            alert(LOCK_MESSAGE);
          }
        });
      });
  }

  // Intercept /cart/update.js requests and revert quantity changes on liner
  // items (quantity 0 = removal is still allowed). Wraps window.fetch exactly
  // once, guarded by a flag.
  function monitorCartAPIRequests() {
    if (window.__epdmFetchPatched) return;
    window.__epdmFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function (url, options) {
      if (
        typeof url === 'string' &&
        url.includes('/cart/update.js') &&
        options &&
        options.body
      ) {
        try {
          var body = JSON.parse(options.body);
          if (body.updates) {
            return originalFetch('/cart.js')
              .then(function (response) {
                return response.json();
              })
              .then(function (cart) {
                var needsBlocking = false;

                cart.items.forEach(function (item) {
                  if (!isEPDMCartApiItem(item)) return;

                  var key = item.key;
                  if (
                    body.updates[key] !== undefined &&
                    parseInt(body.updates[key], 10) !== item.quantity &&
                    parseInt(body.updates[key], 10) !== 0
                  ) {
                    body.updates[key] = item.quantity;
                    needsBlocking = true;
                  }
                });

                if (needsBlocking) {
                  setTimeout(function () {
                    alert(LOCK_MESSAGE);
                  }, 500);
                  options.body = JSON.stringify(body);
                }

                return originalFetch(url, options);
              });
          }
        } catch (e) {
          console.error('Error parsing cart update body:', e);
        }
      }

      return originalFetch.apply(this, arguments);
    };
  }
})();
